export const TEST_DATA = [
  { name: '@leafygreen-ui/example-major', version: '2.0.0' },
  { name: '@leafygreen-ui/example-minor', version: '1.2.0' },
  { name: '@leafygreen-ui/example-patch', version: '1.0.2' },
  { name: '@lg-tools/tool-major', version: '2.0.0' },
  { name: '@lg-tools/tool-minor', version: '1.2.0' },
  { name: '@lg-tools/tool-patch', version: '1.0.2' },
];

export const TEST_CHANGELOG = `
  # example-major

  ## 2.0.0

  ### Major Changes
  - Major update
`;
